import palette from '@lib/core/src/theme/palette';
import { Stack, styled, Typography } from '@mui/material';

export const AiGeneratedTextContainer = styled(Stack)({
  flex: 1,
  height: '100%',
  width: '100%',
  backgroundColor: palette.grey[100],
  borderRadius: '8px',
  padding: '12px',
  overflow: 'auto'
});

export const AiGeneratedText = styled(Typography)({
  fontSize: '13px',
  fontWeight: '700',
  whiteSpace: 'pre-line',
  color: palette.grey[500]
});

export const EditorWrapper = styled(Stack)({
  position: 'relative',
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto'
});

export const InputContainer = styled(Stack)({
  alignItems: 'flex-start',
  gap: '6px',
  width: '100%'
});
